/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { createReduxMiddleware, defaultOptions } from "@karmaniverous/serify-deserify"
import { combineReducers, configureStore } from "@reduxjs/toolkit"

import resultsReducer from "../features/results/ResultsSlice"
import lastSubmittedParametersReducer from "../features/userParameters/LastSubmittedParametersSlice.ts"

const serifyMiddleware = createReduxMiddleware(defaultOptions)

export const store = configureStore({
  reducer: combineReducers({
    results: resultsReducer,
    lastSubmittedParameters: lastSubmittedParametersReducer,
  }),
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(serifyMiddleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
